import { Link } from "react-router-dom";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
  align?: "left" | "center";
}

export default function SectionTitle({
  eyebrow,
  title,
  desc,
  moreTo,
  moreLabel = "查看全部",
  align = "left",
}: SectionTitleProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col gap-4 ${
        isCenter ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <p className="inline-flex items-center gap-2 text-xs font-label tracking-[0.2em] uppercase text-primary-600 mb-3">
            <span className="w-6 h-px bg-primary-500 inline-block"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap self-start md:self-auto"
        >
          {moreLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}